if(typeof FN == 'undefined') FN = {};

FN.storeHelpers = {
  config: {
    orderCompletedURL: 'store/order-completed',
    actions: {
      setCoupon: 'setCoupon',
      setUpgradeLicense: 'setUpgradeLicense',
      changeCountry: 'changeCountry',
      changeEmail: 'changeEmail',
      updateCheckout: 'updateCheckout',
      finalizeCheckout: 'finalizeCheckout'
    },
  	selectors: {
      loadingOverlayClass: 'loading-overlay--fullpage',
      billingInfoZipClass: 'billing__info--zip',
      quantityInput: 'input.seats__amount',
      marketingConsentInputId: 'marketing-consent--yes',
      marketingConsentTextClass: 'marketing-consent__text'
  	}
  },


  /**
  * Validate input field
  */
  validateField: function(fieldSelector){
    switch (fieldSelector) {
      case FN.store.config.selectors.billingFieldEmail:
        if(!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldEmail).val().match(/^.+@.+\..+/g)) {
          return ({ 'message': 'Please provide a valid email address.', 
                    'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldEmail) });
        }
        break;
      case FN.store.config.selectors.billingFieldCountry:
        if(!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCountry).val()) {
          return ({ 'message': 'Please select your country.', 
                    'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCountry) });
        }
        break;
      case FN.store.config.selectors.billingFieldZip:
        if(!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldZip).val()) {
          return ({ 'message': 'Please enter your postal code.', 
                    'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldZip) });
        }
        break;
      case FN.store.config.selectors.billingFieldAddress:
        if(!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldAddress).val()) {
          return ({ 'message': 'Please enter your street address.', 
                    'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldAddress) });
        }
        break;
      case FN.store.config.selectors.billingFieldCity:
        if(!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCity).val()) {
          return ({ 'message': 'Please enter your city.', 
                    'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCity) });
        }
        break;
      case FN.store.config.selectors.billingFieldCompany:
        if(!$('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCompany).val()) {
          return ({ 'message': 'Please enter your company name.', 
                    'fieldSelector': ('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldCompany) });
        }
        break;
      default:
        return null;
    }
  },


  /**
  * Mark all required fields
  */
  highlightRequiredFields: function() {
    var formWrappers = $('.' + FN.store.config.selectors.billingPrimaryClass + ', .' + FN.store.config.selectors.billingSecondaryClass);
    var formElements = formWrappers.find('select, input');
    
    // remove all 'required' CSS classes
    $(formWrappers).find('.billing__info').removeClass('required');
    
    // attach 'required' CSS class only to required fields
    for(var i=0; i<FN.store.cart.requiredFields.length; i++){
      $('#' + FN.store.config.selectors.formID + ' ' + FN.store.cart.requiredFields[i]).closest('.billing__info').addClass('required');
    }
  },
  
  
  /**
  * Make the ZIP field either required or optional (depending on the selected country)
  */
  moveField: function(fieldSelector, fieldset) {
    var fieldElement = $('#' + FN.store.config.selectors.formID + ' ' + fieldSelector);
    var fieldWrapper = $(fieldElement).closest('.billing__info');
    var primaryFieldset = $('fieldset.billing--primary');
    var secondaryFieldset = $('fieldset.billing--secondary');

    if(!fieldset){
      fieldset = ($.inArray(fieldSelector, FN.store.cart.requiredFields) >= 0) ? 'primary' : 'secondary';
    }
    
    if(fieldset === "primary"){
      // --> move field up to required fieldset
      if($(secondaryFieldset).find(fieldElement).length === 1){
        $(fieldWrapper).detach().appendTo(primaryFieldset);
      }
    }else{
      // --> move field down to secondary fieldset
      if($(primaryFieldset).find(fieldElement).length === 1){
        $(fieldWrapper).detach().appendTo(secondaryFieldset);
      }
    }
  },
  
  
  /**
  * Show or hide the secondary fieldset
  */
  toggleSecondaryFields: function(show) {
    var showSecondaryFields = false;
    if(show === true){
      showSecondaryFields = true;
    }else if(show === false){
      showSecondaryFields = false;
    }else{
      // check if any secondary field is required - then show!
      if( $.inArray(FN.store.config.selectors.billingFieldCompany, FN.store.cart.requiredFields) >= 0 ||
          $.inArray(FN.store.config.selectors.billingFieldAddress, FN.store.cart.requiredFields) >= 0 ||
          $.inArray(FN.store.config.selectors.billingFieldCity, FN.store.cart.requiredFields) >= 0){
            showSecondaryFields = true;
      }
    }

    if(showSecondaryFields === true){
      $('.'+FN.store.config.selectors.billingSecondaryClass).show();
    }else if(show === false){
      $('.'+FN.store.config.selectors.billingSecondaryClass).hide();
    }
  },
  
  
  /**
  * Determine if the seat amount can be changed by the user
  * - if amount can be changed: returns false
  * - if amount is fixed: returns integer of fixed amount
  */
  isQuantityFixed: function() {
    if(FN.checkout.plan.max_quantity && FN.checkout.plan.min_quantity && FN.checkout.plan.max_quantity === FN.checkout.plan.min_quantity){
      return FN.checkout.plan.max_quantity;
    }else{
      return false;
    }
  },
  
  
  /**
  * Display the status of the cart (above the "Proceed to Payment" button), esp. for validation errors / missing required fields etc.
  */
  displayCartStatus: function(cartStatus) {
    var messageContainer = $('.validation-message');
    var messageHtml = '';
    for(var i=0; i<cartStatus.messages.length; i++){
      messageHtml += '<p>'+ cartStatus.messages[i].message +'</p>';
    }

    $(messageContainer).html(messageHtml).removeClass('success error loading').addClass(cartStatus.status);
    if(cartStatus.messages.length == 0){
      $(messageContainer).hide();
    }else{
      $(messageContainer).show();
    }
  },


  /**
  * Paddle callback - when a payment was successful
  */
  paymentWasSuccessful: function(data) {
    // log in analytics
    if(typeof dataLayer !== 'undefined'){
      var analyticsEvent = {'event': 'customEvent', 'eventCategory': 'store', 'eventAction': 'paymentSuccessful', 'eventLabel': ''};
      dataLayer.push(analyticsEvent);
    }
    
    // unset 'coupon' cookie
    if(typeof Cookies !== 'undefined'){
      Cookies.remove('coupon');
    }
    
    // redirect to "Order Completed" page
    var redirectURL = FN.config.urls.base + FN.storeHelpers.config.orderCompletedURL;
    var urlParams = {};

    if (FN.checkout) {
      if ('email' in FN.checkout) {
        urlParams['email'] = FN.checkout.email;
      }
      if ('reference_number' in FN.checkout) {
        urlParams['order_id'] = FN.checkout.reference_number;
      }
      if (('plan' in FN.checkout) && FN.checkout.plan.title) {
        urlParams['plan_title'] = FN.checkout.plan.title;
      }
      if (('total_price' in FN.checkout) && !isNaN(FN.checkout['total_price'])) {
        urlParams['total_price'] = FN.checkout['total_price'].toFixed(2);
      }
      if ('currency' in FN.checkout) {
        urlParams['currency'] = FN.checkout['currency'];
      }
    }
    
    if(!jQuery.isEmptyObject(urlParams)){
      redirectURL += '?' + $.param(urlParams);
    }

    // perform redirect
    window.location = redirectURL;
  },


  /**
  * Paddle callback - when the overlay was closed (= payment was cancelled)
  */
  paymentWasCancelled: function(data) {
    // log in analytics
    if(typeof dataLayer !== 'undefined'){
      var analyticsEvent = {'event': 'customEvent', 'eventCategory': 'store', 'eventAction': 'paymentCancelled', 'eventLabel': ''};
      dataLayer.push(analyticsEvent);
    }
    
    // allow changing quantity again (we set it to 'readonly' to prevent 1Password from changing the quantity when a CreditCard is selected)
    var quantityInput = $(FN.storeHelpers.config.selectors.quantityInput);
    if(quantityInput.length > 0) {
      $(quantityInput).attr('readonly', false);
    }
  },
  
  
  /**
  * Subscribe to newsletter
  */
  subscribeToNewsletter: function() {
  	var optInChecked = $('#' + FN.storeHelpers.config.selectors.marketingConsentInputId).prop('checked');
  	var email = $('#' + FN.store.config.selectors.formID + ' ' + FN.store.config.selectors.billingFieldEmail).val();
  	
  	if(!optInChecked || !email) return false;
    
    var marketingConsentText = $('.' + FN.storeHelpers.config.selectors.marketingConsentTextClass).text();
  	var requestURL = FN.config.urls.apiBase + FN.config.urls.apiContactSubscribe;
  	var requestData = { 
  		"email": email,
  		"lists": ["tower-newsletter"],
  		"tags": ["tower_newsletter"],
  		"signup": {"medium": "tower-website", "URI": "store", "OS": FN.helpers.platform()},
  		"doubleOptIn": null,
      "consent": {"date": (new Date()).toUTCString(), "text": (marketingConsentText ? marketingConsentText : null) }
  	};

  	FN.remoteRequest.sendRequest(requestURL, requestData, false);
  },


  /**
  * Toggle full-size loading overlay
  */
  toggleLoadingOverlay: function(show) {
    if(show){
      html = '<div class="' + FN.storeHelpers.config.selectors.loadingOverlayClass + '"></div>';
      $('body').append(html);
      
    }else{
      $('.' + FN.storeHelpers.config.selectors.loadingOverlayClass).remove();
    }
  },
  
  
  /**
  * Currency-aware formatting of the price amount  
  */
  formatCurrency: function(amount, currency) {
    var formattedCurrency,
        amountString;
    
    switch(currency) {
      case 'USD':
        amountString = FN.storeHelpers.formatCurrencyNumber(amount, 2, '.', ',');
        formattedCurrency = 'USD ' + amountString;
        break;
      case 'EUR':
        amountString = FN.storeHelpers.formatCurrencyNumber(amount, 2, ',', '.');
        formattedCurrency = amountString + '<span> €</span>';
        break;
      case 'GBP':
        amountString = FN.storeHelpers.formatCurrencyNumber(amount, 2, '.', ',');
        formattedCurrency = '£ ' + amountString;
        break;
      case 'JPY':
        amountString = FN.storeHelpers.formatCurrencyNumber(amount, 0, '.', ',');
        formattedCurrency = '¥ ' + amountString;
        break;
      default:
        amountString = FN.storeHelpers.formatCurrencyNumber(amount, 2, '.', ',');
        formattedCurrency = currency + ' ' + amountString;
        break;
    }
    
    return formattedCurrency;
  },
  
  
  /**
  * Format a given price number, taking delimiter and precision into account
  */
  formatCurrencyNumber: function(amount, precision, decimalDelimiter, thousandsDelemitier){
    var precision = (isNaN(precision = Math.abs(precision))) ? 2 : precision;
    var decimalDelimiter = (decimalDelimiter == undefined) ? "." : decimalDelimiter;
    var thousandsDelemitier = (thousandsDelemitier == undefined) ? "," : thousandsDelemitier;
    var minus = (amount < 0) ? "-" : "";
    
    var amountString = String(parseInt(Math.abs(Number(amount)).toFixed(precision)));
    var preThousandDelimiterChars = (amountString.length > 3) ? amountString.length % 3 : 0;

    var preComma = (preThousandDelimiterChars ? amountString.substr(0, preThousandDelimiterChars) + thousandsDelemitier : "") + amountString.substr(preThousandDelimiterChars).replace(/(\d{3})(?=\d)/g, "$1" + thousandsDelemitier);
    var postComma = (precision ? decimalDelimiter + Math.abs(amount - amountString).toFixed(precision).slice(2) : "");

    return minus + '<span class="amount__pre-comma">' + preComma + '</span>' + '<span class="amount__post-comma">' + postComma + '</span>';
  }
}
